<script>
import { defineComponent, reactive, toRef, toRefs, ref, computed } from '@vue/composition-api'

function arrayToObject(array) {
  const newObj = Object.create(null)
  array.forEach(item => (newObj[item.prop] = item?.ui?.initialValue))
  return newObj
}

export default defineComponent({
  name: 'MlForm',
  props: ['schema'],
  setup(props) {
    const { schema } = toRefs(props)

    const formAttrs = reactive({
      ref: 'formRef',
      model: arrayToObject(schema.value),
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
    })

    const formRef = ref()

    function validate() {
      return formRef.value.validate()
    }

    return {
      formAttrs,
      formRef,
      validate,
    }
  },
})
</script>

<template>
  <a-form-model v-bind="formAttrs">
    <a-row>
      <a-col v-for="item in schema" :key="item.prop" :span="item.span || 24">
        <a-form-model-item
          v-bind="item"
          :label="$t(item.label || '')"
          :rules="item.rules ? item.rules.map(item => ({ ...item, message: $t(item.message) })) : []"
        >
          <template v-if="!item.ui || item.ui.hidden"></template>
          <template v-else-if="!item.ui.widget || item.ui.widget === 'input'">
            <a-input :placeholder="$t('common_please_input') + $t(item.label || '')" v-bind="item.ui" v-model="formAttrs.model[item.prop]" />
          </template>
          <template v-else-if="item.ui.widget === 'input-number'">
            <a-input-number v-bind="item.ui" v-model="formAttrs.model[item.prop]" />
          </template>
          <template v-else-if="item.ui.widget === 'textarea'">
            <a-textarea :placeholder="$t('common_please_input') + $t(item.label || '')" v-bind="item.ui" v-model="formAttrs.model[item.prop]" />
          </template>
          <template v-else-if="item.ui.widget === 'select'">
            <a-select :placeholder="$t('please_select') + $t(item.label || '')" v-bind="item.ui.attrs" v-model="formAttrs.model[item.prop]" v-on="item.ui.events">
              <a-select-option v-for="option of item.ui.enum" :key="option.value">{{ option.label }}</a-select-option>
            </a-select>
          </template>
          <template v-else>
            <slot :name="item.ui.widget" :item="item" :model="formAttrs.model"></slot>
          </template>
        </a-form-model-item>
      </a-col>
    </a-row>
  </a-form-model>
</template>
